export default {
  apiKey: process.env.GATSBY_FIREBASE_apiKey,
  authDomain: process.env.GATSBY_FIREBASE_authDomain,
  databaseURL: process.env.GATSBY_FIREBASE_databaseURL,
  projectId: process.env.GATSBY_FIREBASE_projectId,
  storageBucket: process.env.GATSBY_FIREBASE_storageBucket,
  messagingSenderId: process.env.GATSBY_FIREBASE_messagingSenderId
};
